import { MetricField, MetricUnit } from '@/__generated__/graphql';
import { type I18n } from '@lingui/core';
import { getUnitsPerMetric } from '@/utils/getUnitsPerMetric';

export const CENTIMETER_FIELDS: MetricField[] = [
  MetricField.Level,
  MetricField.OriginalDistance,
  MetricField.OriginalDistanceRaw,
  MetricField.Position,
  MetricField.LevelRaw,
  MetricField.SnowLevel,
  MetricField.SnowLevelRaw,
  MetricField.SnowLevelNonCalibrated,
  MetricField.SnowWaterEquivalent,
  MetricField.SnowWaterEquivalentRaw,
  MetricField.SnowWaterEquivalentNonCalibrated,
];

export const CUBIC_METER_FIELDS: MetricField[] = [
  MetricField.VolumeM3,
  MetricField.VolumeDay,
  MetricField.VolumeHour,
  MetricField.VolumeMonth,
  MetricField.StoredVolume,
  MetricField.CalculatedVolume,
  MetricField.AccumulatedVol,
  MetricField.AccumulatedVolRaw,
  MetricField.OriginalVol,
  MetricField.OriginalVolRaw,
  MetricField.AccumulatedVolume,
  MetricField.DgaAccumulatedVolume,
];

export const getDefaultUnit = (field: MetricField, i18n: I18n): MetricUnit | null => {
  if (CENTIMETER_FIELDS.includes(field)) return MetricUnit.Centimeter;
  if (CUBIC_METER_FIELDS.includes(field)) return MetricUnit.CubicMeter;
  return getUnitsPerMetric(field, i18n).at(0)?.enumValue ?? null;
};

/** Converts a MetricUnit enum value to its string representation (e.g. "l/s"). */
export const getUnitValue = (field: MetricField, unit: MetricUnit | undefined, i18n: I18n): string => {
  const units = getUnitsPerMetric(field, i18n);
  if (unit) {
    return units.find((u) => u.enumValue === unit)?.value ?? units.at(0)?.value ?? '';
  }
  return units.at(0)?.value ?? '';
};
